import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MessageBusService {
    onPaymentAuthorized = new Subject<boolean>();
    onOrderAccepted = new Subject<boolean>();
}
